export {
  BrandDetail,
  BOTPromotionsLink,
  BrandBreadcrumbs,
  BrandRefinementMenu,
  BrandGuidedNavigation,
  BrandLines,
  BOTCommonBrandTireResultList,
  BOTBrandMarketingSpotligh,
  BrandDetailAndMarketingSpotligh
} from '../BrandDetailsPage'
export { default as OneColumnBrandPage } from '../OneColumnBrandPage/OneColumnBrandPage'
